<template>
  <div class="aboutWrapper">
    <dwgwcontenheader :imgsrc="img"></dwgwcontenheader>
    <dwgwcontenstabs :contentsList="contentsList"></dwgwcontenstabs>
  </div>
</template>

<script>
import dwgwcontenheader from "@/components/dwgwcontenheader";
import dwgwcontenstabs from "@/components/dwgwcontenstabs";
export default {
  name: "dwgwabout",
  components: {
    dwgwcontenheader,
    dwgwcontenstabs,
  },
  data() {
    return {
      img: require("./jpg/index1_1.png"),
      contentsList: [
        {
          title: "关于'蝶威'",
          contentData: [
            "浙江蝶威资产管理有限公司成立于2018年4月，是一家以人工智能量化投资策略为主的私募资产管理机构。",
            "公司致力于探索数学科学、人工智能与投资实践、投资逻辑的完美结合。公司凭借核心成员的长期证券投资经验和量化投资经验，依托先进的大数据分析和数学建模技术，在各类金融产品上进行高中低频策略和套利策略的研发，力求在不同周期、不同市场环境下都带来可观且比较稳定的投资回报。",
          ],
        },
        {
          title: "'蝶威'起源",
          contentData: [
            "'蝶威'起源于蝴蝶效应。蝴蝶效应是指在一个动态系统中，初始条件的微小变化，将能带动整个系统长期且巨大的链式反应，是一种混沌现象。对于这个效应最通俗的阐述是“一只蝴蝶在巴西轻拍翅膀，可以导致一个月后德克萨斯州的一场龙卷风”。而金融市场就是典型的具有蝴蝶效应的、极其复杂的动态系统。",
            "蝶威是蝴蝶效应之威力的简称，我们将深入研究、科学应对金融市场上蝴蝶效应之威力。",
            "英文名DeepWin是蝶威的谐音，同时衍生于DeepMind，隐喻我们致力于把人工智能技术应用于金融市场和量化投资领域。",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.aboutWrapper {
  width: 1140px;
  margin: 0 auto;
  margin-top: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwabout.vue